const breakpoints = {
  xsmall: "23.125rem", // 370px
  small: "36rem", // 576px
  medium: "48rem", // 768px
  large: "59.25rem", // 948px
  xlarge: "75rem", // 1200px
  xxlarge: "90rem", // 1440px
}

const customProperties = {
  "--xsmall": breakpoints.xsmall,
  "--small": breakpoints.small,
  "--medium": breakpoints.medium,
  "--large": breakpoints.large,
  "--xlarge": breakpoints.xlarge,
  "--xxlarge": breakpoints.xxlarge,
}

const customMedia = {
  "--xsmall-up": `only screen and (width >= ${breakpoints.xsmall})`,
  "--small-up": `only screen and (width >= ${breakpoints.small})`,
  "--medium-up": `only screen and (width >= ${breakpoints.medium})`,
  "--large-up": `only screen and (width >= ${breakpoints.large})`,
  "--xlarge-up": `only screen and (width >= ${breakpoints.xlarge})`,
  "--xxlarge-up": `only screen and (width >= ${breakpoints.xxlarge})`,
  "--small-only": `only screen and (width < ${breakpoints.medium})`,
  "--medium-only": `only screen and (${breakpoints.small} < width < ${breakpoints.medium})`,
  "--large-only": `only screen and (${breakpoints.medium} < width < ${breakpoints.large})`,
  "--xlarge-only": `only screen and (${breakpoints.large} < width < ${breakpoints.xlarge})`,
}

const mediaQueries = {
  xsmallUp: customMedia["--xsmall-up"],
  smallUp: customMedia["--small-up"],
  mediumUp: customMedia["--medium-up"],
  largeUp: customMedia["--large-up"],
  xlargeUp: customMedia["--xlarge-up"],
  xxlargeUp: customMedia["--xxlarge-up"],
  smallOnly: customMedia["--small-only"],
  mediumOnly: customMedia["--medium-only"],
  largeOnly: customMedia["--large-only"],
  xlargeOnly: customMedia["--xlarge-only"],
}

function matches(query) {
  return window.matchMedia(query).matches
}

function isXsmallUp() {
  return matches(mediaQueries.xsmallUp)
}

function isSmallUp() {
  return matches(mediaQueries.smallUp)
}

function isMediumUp() {
  return matches(mediaQueries.mediumUp)
}

function isLargeUp() {
  return matches(mediaQueries.largeUp)
}

function isXlargeUp() {
  return matches(mediaQueries.xlargeUp)
}

function isXxlargeUp() {
  return matches(mediaQueries.xxlargeUp)
}

function isSmallOnly() {
  return matches(mediaQueries.smallOnly)
}

function isMediumOnly() {
  return matches(mediaQueries.mediumOnly)
}

function isLargeOnly() {
  return matches(mediaQueries.largeOnly)
}

function isXlargeOnly() {
  return matches(mediaQueries.xlargeOnly)
}

module.exports = {
  breakpoints,
  customProperties,
  customMedia,
  mediaQueries,
  matches,
  isXsmallUp,
  isSmallUp,
  isMediumUp,
  isLargeUp,
  isXlargeUp,
  isXxlargeUp,
  isSmallOnly,
  isMediumOnly,
  isLargeOnly,
  isXlargeOnly,
}
